import React from 'react';
import './Cards.css';
import CardItem from './CardItem';

function Cards() {
  return (
    <div className='cards'>
      <p>Welcome to my portfolio of projects! Each endeavor showcased below represents a labor of passion and dedication,
        reflecting my commitment to innovation and problem-solving. From web applications that streamline user experiences to 
        intricate coding challenges that pushed the boundaries of my technical skills, these projects are a testament to my 
        journey as a developer. I invite you to explore the diverse range of endeavors, each contributing to a richer understanding of my 
        capabilities and the unique problems I've had the privilege to solve. Whether it's building robust web applications or diving into 
        cutting-edge technologies, I am excited to share my journey with you through these projects. Enjoy the exploration!</p>
      <div className='cards__container'>
        <div className='cards__wrapper'>
          <ul className='cards__items'>
            <CardItem
              src='images/galagaScreenshot.png'
              text='Classic arcade shooter: Galaga, swarm aliens, epic space battles, nostalgia unleashed'
              path='/projects'
            />
            <CardItem
              src='images/stockChecker.png' 
              text='Python stock scraper: Real-time data, trends, analytics for informed investments'
              path='/projects'
            />
          </ul>
          <ul className='cards__items'>
            <CardItem
              src='images/marioGame.png'
              text='Mario platformer: Mushroom adventures, power-ups, obstacles, save Princess Peach triumph.'
              path='/projects'
            />
            <CardItem
              src='images/rubikscubetimer.png'
              text="Precision timer: Solve Rubik's Cube, track speed, improve solving skills."
              path='/projects'  
            />
            <CardItem
              src='images/networkMinipulator.png'
              text='Windows PowerShell app: Network manipulation tool, automate tasks, streamline operations.'
              path='/projects'
            />
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Cards;